<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<ng-container *ngIf="isScreenSmall">
  <fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="'over'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="false">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <!-- Logo -->
      <a href="{{ homeUrl }}" title="Dashboard">
        <div class="flex items-center p-6 pb-0">
          <!-- <img
          class="w-full"
          src="assets/images/logo/sbd-logo-horizontal-white-with-shadow.png"
          alt="Doug"> -->

          <img class="w-6" src="assets/images/logo/doug-beard.png" alt="Doug" />
          <span class="text-2xl text-bold ml-4">Doug</span>
        </div>
      </a>
    </ng-container>
  </fuse-vertical-navigation>
</ng-container>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0 border-t-2 border-t-brandOrange">
  <!-- Header -->
  <div
    class="relative flex flex-0 items-center w-full h-16 sm:h-20 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
    <ng-container *ngIf="!isScreenSmall">
      <!-- Logo -->
      <a href="{{ homeUrl }}" title="Dashboard" class="mr-4">
        <div class="flex items-center">
          <!-- <img
          class="w-full"
          src="assets/images/logo/sbd-logo-horizontal-white-with-shadow.png"
          alt="Doug"> -->

          <img class="w-6" src="assets/images/logo/doug-beard.png" alt="Doug" />
          <span class="text-2xl text-bold ml-4">Doug</span>
        </div>
      </a>
      <!-- Horizontal navigation -->
      <fuse-horizontal-navigation
        class="mr-2"
        [name]="'mainNavigation'"
        [navigation]="navigation.horizontal"></fuse-horizontal-navigation>
    </ng-container>
    <!-- Navigation toggle button -->
    <ng-container *ngIf="isScreenSmall">
      <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
        <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
      </button>
      <a href="{{ homeUrl }}" title="Dashboard">
        <div class="ml-3 flex items-center">
          <!-- <img
          class="w-full"
          src="assets/images/logo/sbd-logo-horizontal-white-with-shadow.png"
          alt="Doug"> -->

          <img class="w-6" src="assets/images/logo/doug-beard.png" alt="Doug" />
          <span class="text-2xl text-bold ml-4">Doug</span>
        </div>
      </a>
    </ng-container>
    <!-- Components -->
    <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
      <!-- <languages></languages> -->
      <!-- <fuse-fullscreen class="hidden md:block"></fuse-fullscreen> -->
      <search [appearance]="'bar'"></search>
      <!-- <shortcuts></shortcuts> -->
      <!-- <messages></messages> -->
      <!-- <notifications></notifications> -->
      <!-- <button
          class="lg:hidden"
          mat-icon-button
          (click)="quickChat.toggle()">
          <mat-icon [svgIcon]="'heroicons_outline:chat-alt-2'"></mat-icon>
      </button> -->
      <user showAvatar="true"></user>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-col md:flex-row flex-auto w-full min-h-0">
    <div class="flex flex-col flex-auto min-w-0">
      <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
               Otherwise, layout changes won't be registered and the view won't be updated! -->
      <router-outlet *ngIf="true"></router-outlet>
    </div>

    <div
      *ngIf="!isScreenSmall && drawerTabs().length > 0"
      class="md:w-[50px] shrink-0 border-l border-gray-200 dark:border-gray-700 bg-card dark:bg-transparent flex flex-col items-center justify-start py-2 gap-2 print:hidden">
      <button
        *ngFor="let tab of desktopVisibleDrawerTabs()"
        type="button"
        class="w-9 h-28 rounded-md flex flex-col items-center justify-center border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-slate-800 overflow-hidden shrink-0"
        [ngClass]="{
          'bg-brandBlue text-white border-brandBlue': isDrawerTabActive(tab.id),
        }"
        [matTooltip]="tab.title"
        (click)="onDrawerTabClicked(tab)">
        <mat-icon class="icon-size-4 flex-shrink-0 md:hidden" [svgIcon]="tab.icon"></mat-icon>
        <div class="hidden md:flex items-center gap-1 max-w-[84px] -rotate-90 origin-center">
          <mat-icon class="icon-size-3 flex-shrink-0" [svgIcon]="tab.icon"></mat-icon>
          <span class="overflow-hidden text-ellipsis whitespace-nowrap text-[10px] leading-none uppercase tracking-[0.04em]">
            {{ tab.title }}
          </span>
        </div>
      </button>

      <button
        *ngIf="overflowDrawerTabs().length > 0"
        mat-icon-button
        type="button"
        class="mt-auto mb-1 border border-gray-200 dark:border-gray-700 rounded-md"
        [matMenuTriggerFor]="desktopOverflowMenu"
        matTooltip="More tabs">
        <mat-icon [svgIcon]="'heroicons_outline:menu-alt-2'"></mat-icon>
      </button>

      <mat-menu #desktopOverflowMenu="matMenu">
        <button mat-menu-item *ngFor="let tab of overflowDrawerTabs()" (click)="onDrawerTabMenuSelect(tab)">
          <mat-icon [svgIcon]="tab.icon"></mat-icon>
          <span class="truncate max-w-[180px]">{{ tab.title }}</span>
        </button>
      </mat-menu>
    </div>

    <div
      *ngIf="isScreenSmall && drawerTabs().length > 0"
      class="h-[52px] shrink-0 border-t border-gray-200 dark:border-gray-700 bg-card dark:bg-transparent flex items-center px-2 print:hidden">
      <button
        *ngIf="mobilePrimaryDrawerTab() as primaryTab"
        type="button"
        class="flex-1 min-w-0 h-9 rounded-md flex items-center gap-2 px-2 border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-slate-800"
        [ngClass]="{
          'bg-brandBlue text-white border-brandBlue': isDrawerTabActive(primaryTab.id),
        }"
        [matTooltip]="primaryTab.title"
        (click)="onDrawerTabClicked(primaryTab)">
        <mat-icon class="icon-size-4 flex-shrink-0" [svgIcon]="primaryTab.icon"></mat-icon>
        <span class="truncate text-sm font-medium">
          {{ primaryTab.title }}
        </span>
      </button>

      <button
        mat-icon-button
        type="button"
        [matMenuTriggerFor]="mobileDrawerTabsMenu"
        [disabled]="mobileOverflowDrawerTabs().length === 0">
        <mat-icon [svgIcon]="'heroicons_outline:dots-vertical'"></mat-icon>
      </button>

      <mat-menu #mobileDrawerTabsMenu="matMenu">
        <button mat-menu-item *ngFor="let tab of mobileOverflowDrawerTabs()" (click)="onDrawerTabMenuSelect(tab)">
          <mat-icon [svgIcon]="tab.icon"></mat-icon>
          <span class="truncate max-w-[180px]">{{ tab.title }}</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <!-- Footer -->
  <!-- <div
    class="relative flex flex-0 items-center w-full h-14 sm:h-20 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden"
  >
    <span class="font-medium text-secondary"
      >Fuse &copy; {{ currentYear }}</span
    >
  </div> -->
</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
